import React, { useEffect, useRef, useState } from "react";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper.js";
import { transformTime } from "./helpers.js";

export const useUploadingSpeed = (fineUploaderFilesPorgress) => {
  /**
   * uploadSpeed and estimationTime calculation start
   * -----------------------------------------------
   */

  const { getSize, getUploading, getIsUppy, getUploader } = useUploader();
  const [uploadSpeed, setUploadSpeed] = useState("");
  const [estimationTime, setEstimationTime] = useState("");
  const [estimationSeconds, setEstimationSeconds] = useState(0);
  const [progress, setProgress] = useState(0);
  const [filesProgress, setFilesProgress] = useState({});

  const prevSizeRef = useRef(0);
  const deltaRef = useRef(0);
  const uploadedSizeRef = useRef(0);

  const getuploadedSize = () => {
    let uploadedSize = 0;
    Object.entries(filesProgress).forEach(([key, value]) => {
      if (value !== "error") uploadedSize += value;
    });
    return uploadedSize;
  };

  // useEffect(() => {
  //   if (getIsUppy()) {
  //     const uppy = getUploader();
  //     uppy.on("upload-progress", (file, progress) => {
  //       setFilesProgress((prev) => {
  //         return { ...prev, [file.id]: progress.bytesUploaded };
  //       });
  //     });
  //     uppy.on("progress", (progress) => {
  //       setProgress(progress);
  //     });
  //   }
  // }, []);

  useEffect(() => {
    if (!getIsUppy()) {
      setFilesProgress(fineUploaderFilesPorgress);
    }
  }, [fineUploaderFilesPorgress]);

  useEffect(() => {
    uploadedSizeRef.current = getuploadedSize();
    if (!getIsUppy()) {
      const progress = Math.round((uploadedSizeRef.current / getSize()) * 100);
      setProgress(
        progress === 100 && uploadedSizeRef.current !== getSize()
          ? 99
          : progress
      );
    }
  }, [filesProgress]);

  const calculate = () => {
    // detecting delta between current uploaded size and 3s ago
    const delta = uploadedSizeRef.current - prevSizeRef.current;
    //taking avarage from prev delta and current delta and deviding it by 3s
    const currenUploadSpeed = (delta + deltaRef.current) / 2 / 3;
    const transformedSpeed = bytesToDisplayHelper(currenUploadSpeed);
    if (transformedSpeed.size > 0) {
      setUploadSpeed(transformedSpeed.size + transformedSpeed.type);
    } else {
      setUploadSpeed("");
    }
    const estimationTime =
      (getSize() - uploadedSizeRef.current) / currenUploadSpeed;
    if (estimationTime > 0 && isFinite(estimationTime)) {
      setEstimationSeconds(estimationTime);
      setEstimationTime(transformTime(estimationTime));
    } else {
      setEstimationTime("");
    }

    // upadting deltaref as a current delta
    deltaRef.current = delta;
    // updating prevSizeRef as current total size
    prevSizeRef.current = uploadedSizeRef.current;
  };
  // start calculating every 3s when uploading is started
  // and stop before component unmount
  useEffect(() => {
    if (getUploading()) {
      const intervalId = setInterval(calculate, 3000);
      const func = () => {
        clearInterval(intervalId);
      };
      window.addEventListener("beforeunload", func);

      return () => {
        window.removeEventListener("beforeunload", func);
        clearInterval(intervalId);
      };
    }
  }, [getUploading()]);

  /**
   * -----------------------------------------------
   * uploadSpeed and estimationTime calculation end
   */

  return {
    uploadSpeed,
    estimationTime,
    progress,
    getuploadedSize,
    estimationSeconds,
  };
};
